import { useNavigate, useParams } from 'react-router-dom'
import { NAVIGATION_DEFAULT_LOCALE } from 'src/types/locales'

/**
 * Hook that returns a navigate function with automatic locale support
 * Similar to next-intl's useRouter
 */
export const useLocalizedNavigate = () => {
  const navigate = useNavigate()
  const { locale } = useParams<{ locale: string }>()
  const currentLocale = locale || NAVIGATION_DEFAULT_LOCALE

  const localizedNavigate = (to: string | number, options?: any) => {
    // If it's a number (go back/forward), pass through
    if (typeof to === 'number') {
      return navigate(to)
    }

    // If path already starts with a locale, return as is
    const localizedPath = to.match(/^\/(fr|en)\//)
      ? to
      : `/${currentLocale}${to.startsWith('/') ? to : `/${to}`}`

    return navigate(localizedPath, options)
  }

  return localizedNavigate
}
